//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from 'lodash';
import Field from '../field/index.vue';
import TextField from '../../../../components/textField';

export default ({
  components: {
    Field,
  },
  extends: TextField,
  props: {
    debounce: {
      default: false,
      type: Boolean,
    },
    debounceDelayMs: {
      default: 250,
      type: Number,
    },
    errorMessageColor: {
      validator: (value) => {
        return ['white', 'red', 'pink'].includes(value);
      },
      default: 'red',
    },
    errorStyle: {
      type: String,
      default: 'outline',
      validator: (value) => {
        return ['outline', 'fill'].indexOf(value) !== -1;
      },
    },
    rect: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.onInputDebounce = debounce(function (event) {
      this.$emit('input', event.target.value);
    }, this.debounceDelayMs);
  },
});
